<template>
  <div v-if="currentRoles.name === '商品管理'" class="page-index product-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['商品管理-新增']" class="btn-left" size="mini" @click="openModel">添加商品</el-button>
      <!-- <el-button v-if="currentRoles.roles['商品管理-新增']" class="btn-left" size="mini" @click="openModel2">excel导入</el-button> -->
      <!-- 暂时隐藏sap导入入口 2025-09-04 -->
      <el-button v-if="currentRoles.roles['商品管理-新增']" class="btn-left" size="mini" @click="handleSap">sap导入</el-button>
      <div style="flex:1"></div>
      <el-select class="search-input" v-model="companyId" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="使用中" value="0"></el-option>
        <el-option label="已禁用" value="1"></el-option>
      </el-select>
      <el-input class="search-input" size="mini" v-model="query" @keyup.enter.native="seach" placeholder="请输入商品名称或编号" />
      <!-- <el-input class="search-input" size="mini" v-model="code" @keyup.enter.native="seach" placeholder="请输入商品编号" /> -->
    </div>
    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
       <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="商品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="code"
          label="商品编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="描述">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="操作">
        <template slot-scope="scope">
          <el-tooltip v-if="currentRoles.roles['商品管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="openModel3(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['商品管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加商品"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="productForm" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="商品名称" prop="name">
          <el-input placeholder="请输入商品名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="商品编码" prop="code">
          <el-input placeholder="请输入商品编码" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="companyId">
          <el-select class="search-input" v-model="form.companyId" @change="_getPropertyList" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品标准编号">
          <el-input placeholder="请输入产品标准编号" v-model="form.standardNumber"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input placeholder="请输入描述" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item v-for="(item, index) in propertyList" :key="item.id" :label="item.name">
          <el-input v-if="item.type === 1" :placeholder="'请输入' + item.name" v-model="form.productPropertyList[index].value"></el-input>
          <template v-if="item.type === 2">
            <el-radio v-for="value in item.values" :key="value" :label="value" v-model="form.productPropertyList[index].value">{{value}}</el-radio>
          </template>
          <el-checkbox-group v-if="item.type === 3" v-model="form.productPropertyList[index].value">
            <el-checkbox v-for="value in item.values" :key="value" :label="value"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="excel导入商品"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="productForm2" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="公司" prop="companyId">
          <el-select class="search-input" v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" prop="file">
          <el-upload
              ref="fileUpload"
              action=""
              :limit="1"
              :auto-upload="false"
              :on-change="handleChange"
              :on-remove="handleRemove">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx或者xls格式的文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleExcel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改商品"
        :visible.sync="dialogVisible3"
        width="550px"
        :before-close="handleClose">
      <el-form ref="productForm3" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="商品名称" prop="name">
          <el-input placeholder="请输入商品名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="产品标准编号">
          <el-input placeholder="请输入产品标准编号" v-model="form.standardNumber"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input placeholder="请输入描述" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item v-for="item in form.productPropertyList" :key="item.id" :label="item.propertyName">
          <el-input v-if="item.propertyType === 1" :placeholder="'请输入' + item.propertyName" v-model="item.value"></el-input>
          <template v-if="item.propertyType === 2">
            <el-radio v-for="value in item.propertyValues" :key="value" :label="value" v-model="item.value">{{value}}</el-radio>
          </template>
          <el-checkbox-group v-if="item.propertyType === 3" v-model="item.value">
            <el-checkbox v-for="value in item.propertyValues" :key="value" :label="value"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiEdit, apiDelete, apiDetail, apiList, apiUpload, apiSap } from '../../api/product'
  import { apiPropertyList, apiDetail as apiDetaill } from '../../api/property'

  export default {
    mixins: [tableMixin],
    name: 'product-manage',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        list: [],
        propertyList: [],
        productPropertyList: [],
        pageIndex: 1,
        total: 0,
        companyId: '',
        query: '', // 搜索用
        code: '', // 搜索用
        id: 0,
        status: '0',
        form: {
          name: '',
          code: '',
          companyId: '',
          standardNumber: '',
          description: '',
          productPropertyList: []
        },
        rules: {
          name: [
            { required: true, message: '请输入商品名称', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符之内', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入商品编码', trigger: 'blur' },
            { min: 5, max: 10, message: '长度在 5 到 10 个字符', trigger: 'blur' }
          ],
          companyId: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ],
          description: [
            { required: true, message: '请输入描述', trigger: 'blur' }
          ],
          file: [
            { required: true, message: '请选择文件', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.companyId = this.userInfo.companyList[0].id
        this._getList()
      }
    },
    activated() {},
    methods: {
      // 打开model
      openModel() {
        this.dialogVisible = true
        this.form = {
          name: '',
          code: '',
          companyId: this.companyId,
          description: '',
          standardNumber: '',
          productPropertyList: []
        }
        this._getPropertyList()
        if (this.$refs['productForm']) {
          this.$refs['productForm'].resetFields()
        }
      },
      openModel2() {
        this.dialogVisible2 = true
        this.form = {
          companyId: this.companyId,
          file: null
        }
        if (this.$refs['productForm2']) {
          this.$refs['productForm2'].resetFields()
        }
      },
      openModel3(row) {
        this.dialogVisible3 = true
        this.form = {
          name: '',
          description: '',
          standardNumber: '',
          productPropertyList: []
        }
        if (this.$refs['productForm3']) {
          this.$refs['productForm3'].resetFields()
        }
        apiDetail(row.id).then(data => {
          data.data.productPropertyList.forEach((item, index) => {
            item.propertyValues = item.propertyValues.split(',')
            if (item.propertyType === 3) {
              if (item.value !== undefined) {
                item.value = item.value.split(',')
              }
            }
          })
          this.form = data.data
        })
      },
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 文件改变
      handleChange(file, files) {
        let arr = file.name.split('.')
        let suffix = arr[arr.length - 1]
        if (suffix !== 'xlsx' && suffix !== 'xls') {
          this.$refs.fileUpload.clearFiles()
          this.$message({
            type: 'warning',
            message: '请上传xlsx或者xls的文件'
          })
          return
        }
        this.form.file = file
      },
      // 移除文件
      handleRemove() {
        this.form.file = null
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
          this.dialogVisible3 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      _getPropertyList() {
        let productPropertyList = []
        apiPropertyList(this.form.companyId, '', 1, 999).then(data => {
          this.propertyList = []
          data.data.data.forEach(item => {
            let productProperty = {
              propertyId: item.id,
              type: item.type,
              value: ''
            }
            if (item.type === 3) {
              productProperty.value = []
            }
            productPropertyList.push(productProperty)
            if (item.type !== 1) {
              item.values = item.values.split(',')
            }
            this.propertyList.push(item)
          })
          this.form.productPropertyList = productPropertyList
        })
      },
      // 获取列表
      _getList(pageIndex = 1) {
        if (!this.companyId) return
        let params = {
          companyIds: [this.companyId],
          query: this.query
        }
        apiList(params, this.status, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 新增
      handleAdd() {
        this.$refs['productForm'].validate((valid) => {
          if (valid) {
            let product = this.form
            this.form.productPropertyList.forEach((item, index) => {
              if (item.type === 3) {
                this.form.productPropertyList[index].value = item.value.join(',')
              }
            })
            apiEdit(product, this.form.companyId).then(() => {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.dialogVisible = false
              this._getList()
            })
          }
        })
      },
      // sap导入
      handleSap() {
        if (this.companyId) {
          apiSap(this.companyId).then(() => {
            this.$message({
              type: 'success',
              message: '导入成功'
            })
            this._getList()
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请选择公司'
          })
        }
      },
      // excel导入
      handleExcel() {
        this.$refs['productForm2'].validate((valid) => {
          if (valid) {
            let param = new FormData()
            param.append('file', this.form.file.raw, this.form.file.name)
            apiUpload(this.form.companyId, param).then(() => {
              this.$message({
                type: 'success',
                message: '导入成功'
              })
              this.dialogVisible2 = false
              this._getList()
            })
          }
        })
      },
      // 编辑
      handleEdit() {
        this.$refs['productForm3'].validate((valid) => {
          if (valid) {
            let product = {
              id: this.form.id,
              name: this.form.name,
              description: this.form.description,
              productPropertyList: this.form.productPropertyList
            }
            product.productPropertyList.forEach((item, index) => {
              if (item.propertyType === 3) {
                product.productPropertyList[index].value = item.value.join(',')
              }
            })
            apiEdit(product, this.form.companyId).then(() => {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.dialogVisible3 = false
              this._getList()
            })
          }
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除商品：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.product-index
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
